export type ProductModel = {
  NewLine: string;
  SainId: string;
  SkuNumber: string;
  CatNumber: string;
  UnitOfMeasure: string;
  Description: string;
  PackSize: number;
  OuterLength: string;
  OuterWidth: string;
  OuterHeight: string;
  OuterWeight: string;
  OuterNetWeight: string;
  InnerLength: string;
  InnerWidth: string;
  InnerHeight: string;
  InnerWeight: string;
  InnerNetWeight: string;
  Ti: string;
  Hi: string;
  MerchandisingUnit: string;
  Conveyable: string;
  TwoPersonLift: string;
  Uglies: string;
  EAN: string;
  MinimumLifeOnReceipt: string;
  MinimumLifeOnIssue: string;
  BreakPack: string;
  Hazardous: false;
  MultiPart: string;
  ProductType: string;
  FamilyGroup: string;
  Lifecycle: string;
  ActiveDate: string;
  NestedItem: string;
  GrabInBox: string;
  MeasurementRequired: string;
  Validation: string;
  Company: string;
  BusinessUnit: string;
  BusinessUnitDesc: string;
  SuperCategory: string;
  Category: string;
  CategoryDesc: string;
  SubCategory: string;
  SubCategoryDesc: string;
  SuperCatDesc: string;
  Segment: string;
  SegmentDesc: string;
  SkuCount: number;
  MLOR: string;
  MLOI: string;
  Error: string;
};

export const initialValueOfProductModel = {
  SainId: "",
  SkuNumber: "",
  CatNumber: "",
  UnitOfMeasure: "",
  FamilyGroup: "",
  SuperCategory: "",
  Category: "",
  CategoryDesc: "",
  SubCategory: "",
  SubCategoryDesc: null,
  SuperCatDesc: "",
  Segment: "",
  SegmentDesc: "",
  Description: "",
};
